/* eslint-disable import/prefer-default-export */
import { curry } from 'ramda';

const calculateOffset = curry((currentPage, limit) => (currentPage - 1) * limit);
const calculatePage = curry((offset, limit) => (offset / limit) + 1);

export { calculateOffset, calculatePage };
